module.exports = __webpack_public_path__ + "img/problem0.632eac11.png";